package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_11_29_Day_1
import com.veldekar.components.logs.Log_2025_11_29_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-11-29")
@Composable
public fun Log_2025_11_29(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Everyone Loves Entor",
        ogTitle = "Everyone Loves Entor",
        date = LocalDate(2_025, 11, 29),
        aiHint = "Caper and Lord Fox are not actually puppets that's a joke.",
        ogDescription = "DM debuts his one-man show to a packed crowd!",
        ogImage = "images/caperAndFoxMarionette_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of Caper (left) and Lord Fox (right) as marionettes with strings and crosses above them in a training room.",
    ) {
        SessionDayHeader(dayId = "shimmer-8", dateString = "Shimmer 8")
        Log_2025_11_29_Day_1()
        SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9", cardImageSrc = "images/caperAndFoxMarionette_preview.webp", width = 1_200, height = 630)
        Log_2025_11_29_Day_2()
    }
}
